module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    ref: "areaSelector",
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選択して下さい")]), _vm._v(" "), _vm._l((_vm.areaList), function(area) {
    return _c('option', {
      domProps: {
        "selected": area === _vm.value
      }
    }, [_vm._v(_vm._s(area))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7fac15e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AreaSelector.vue
// module id = 90
// module chunks = 1 2